import { Controller } from "@hotwired/stimulus"

// Click-to-add suggestion chips feeding a tag-select input in the same form
// (located by input name via inputNameValue). Used by the bulk import form
// for tumblr tags that don't match the site's vocabulary yet.
export default class extends Controller {
  static values = { inputName: String }

  add(event) {
    const value = event.currentTarget.dataset.tag
    const form = this.element.closest("form")
    const input = (form || document).querySelector(`input[name="${this.inputNameValue}"]`)
    if (!input) return

    const select = input.tomselect
    if (select) {
      select.addOption({ value, text: value })
      select.addItem(value)
    } else {
      input.value = input.value ? `${input.value}, ${value}` : value
    }
    event.currentTarget.remove()
  }
}
